import React from 'react';
import NotFound from '../../NotFound';
import Prismic from 'prismic-javascript';
import {RichText} from 'prismic-reactjs';
import PrismicConfig from '../../prismic-configuration';
import styles from './ProjectOverview.scss';
import HexaContainer from '../HexaContainer/HexaContainer';

export default class ProjectOverview extends React.Component {

    state = {
        showAmount: 0 || this.props.showAmount,
        doc: null,
        notFound: false,
    }
        
    componentWillMount(){
        Prismic.api(PrismicConfig.apiEndpoint).then(api => {
            api.query(
            Prismic.Predicates.at('document.type', 'project'),
            { pageSize : this.state.showAmount }
            ).then(response => {
                if(response.results.length > 0){
                    this.setState({ doc: response.results });
                } else{
                    this.setState({ notFound: true });
                }
            });
        });
    }
    
    render(){
        if (this.state.doc) {
            const document = this.state.doc;
            return (
                <React.Fragment>
                    {document.map(function(doc, index){
                        return (
                            <HexaContainer key={'project_'+index} elements={[
                                <div className={styles.project} key={'project_'+index}>
                                    <h1>{RichText.asText(doc.data.name)}</h1>
                                    <p>{RichText.asText(doc.data.description)}</p>
                                    <a href={PrismicConfig.linkResolver(doc)} key={'read_more_'+index} className={styles.readMore}>Read more</a>
                                </div>
                            ]} type={'project'} backgroundImageUrl={doc.data.featured_image.url} />
                        )
                    })}
                </React.Fragment>
            );
        } else if (this.state.notFound) {
            return <NotFound />;
        }
        return <h1>Loading</h1>;
    }
}


// WEBPACK FOOTER //
// ./src/Components/ProjectOverview/ProjectOverview.js